import { create, useStore } from 'zustand';

export enum SelectedApplicantTab {
  MAIN_APPLICANT = 'main-applicant',
  CO_APPLICANT = 'co-applicant',
}

interface ApplicantsFormState {
  selectedApplicant: SelectedApplicantTab;
  isEditing: boolean;

  actions: {
    setSelectedApplicant(personID: SelectedApplicantTab): void;
    setIsEditing(isEditing: boolean): void;
  };
}

const createApplicantsFormStore = () =>
  create<ApplicantsFormState>((set) => ({
    selectedApplicant: SelectedApplicantTab.MAIN_APPLICANT,
    isEditing: false,
    actions: {
      setSelectedApplicant(selectedApplicant) {
        set(() => ({ selectedApplicant }));
      },
      setIsEditing(isEditing) {
        set(() => ({ isEditing }));
      },
    },
  }));

const applicantsFormStores: Record<
  string,
  ReturnType<typeof createApplicantsFormStore>
> = {};

export function getApplicantsFormStore(applicationID: string) {
  if (!applicantsFormStores[applicationID])
    applicantsFormStores[applicationID] = createApplicantsFormStore();

  return applicantsFormStores[applicationID];
}

export function useApplicantsFormStore(applicationID: string) {
  return useStore(getApplicantsFormStore(applicationID));
}

export function useApplicantsFormStoreActions(applicationID: string) {
  return useStore(
    getApplicantsFormStore(applicationID),
    ({ actions }) => actions,
  );
}
